<template>
  <header class="header">
    <div class="header-content">
      <!-- Logo -->
      <div class="logo">
        <img src="@/assets/logotechnopaws.png" alt="TechnoPaws Logo" class="logo-img">
      </div>

      <!-- Desktop Menu -->
      <nav class="desktop-menu" :class="{ 'hidden': isMobileMenuOpen }">
        <ul class="nav-links">
          <li><a href="#" @click.prevent="scrollToTop">{{ translate('landing.home', 'Home') }}</a></li>
          <li><a href="#services" @click.prevent="scrollToSection('services')">{{ translate('landing.services', 'Services') }}</a></li>
          <li><a href="#pawpulse" @click.prevent="scrollToSection('pawpulse')">{{ translate('landing.pawpulse', 'PawPulse') }}</a></li>
          <li class="aboutus-dropdown">
            <a href="#" class="dropdown-toggle" aria-haspopup="true" aria-expanded="false">{{ translate('landing.about_us', 'About Us') }}</a>
            <ul class="aboutus-menu">
              <li><a href="#key-of-success" @click.prevent="scrollToSection('key-of-success')">{{ translate('landing.key_of_success', 'The Key of Success') }}</a></li>
            </ul>
          </li>
          <li><a href="#contact" @click.prevent="scrollToSection('contact')">{{ translate('landing.contact_us', 'Contact Us') }}</a></li>
        </ul>
      </nav>

      <!-- Social Media & Register -->
      <div class="header-right" :class="{ 'hidden': isMobileMenuOpen }">
        <div class="social-container">
          <a href="https://www.facebook.com/profile.php?id=61567292198505" target="_blank" aria-label="Facebook" class="social-icon facebook">
            <i class="bi bi-facebook"></i>
          </a>
          <a href="https://www.instagram.com/technopaws_us" target="_blank" aria-label="Instagram" class="social-icon instagram">
            <i class="bi bi-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/company/technopaws" target="_blank" aria-label="LinkedIn" class="social-icon linkedin">
            <i class="bi bi-linkedin"></i>
          </a>
          <a href="https://www.youtube.com/@technopawsco" target="_blank" aria-label="YouTube" class="social-icon youtube">
            <i class="bi bi-youtube"></i>
          </a>
          <a href="https://www.tiktok.com/@technopaws_us" target="_blank" aria-label="Tiktok" class="social-icon tiktok">
            <i class="bi bi-tiktok"></i>
          </a>
        </div>
        <button class="register-btn" @click="goToHome">{{ translate('landing.discover_pawpulse', 'Discover PawPulse - Sign In!') }}</button>
      </div>

      <!-- Mobile Menu Button -->
      <button class="mobile-menu-btn" @click="toggleMobileMenu" aria-label="Toggle Menu">
        <span :class="{ 'open': isMobileMenuOpen }"></span>
      </button>

      <!-- Mobile Menu -->
      <div class="mobile-menu" :class="{ 'open': isMobileMenuOpen }">
        <nav>
          <ul>
            <li><a href="#" @click.prevent="scrollToTopAndClose">{{ translate('landing.home', 'Home') }}</a></li>
            <li><a href="#services" @click.prevent="scrollToSectionAndClose('services')">{{ translate('landing.services', 'Services') }}</a></li>
            <li><a href="#pawpulse" @click.prevent="scrollToSectionAndClose('pawpulse')">{{ translate('landing.pawpulse', 'PawPulse') }}</a></li>
            <li><a href="#key-of-success" @click.prevent="scrollToSectionAndClose('key-of-success')">{{ translate('landing.about_us', 'About Us') }}</a></li>
            <li><div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">{{ translate('landing.key_of_success', 'Key of Success') }}</h6>
                            </div></li>
            <li><a href="#contact" @click.prevent="scrollToSectionAndClose('contact')">{{ translate('landing.contact_us', 'Contact Us') }}</a></li>
            <li class="mobile-social">
              <div class="social-container">
                <a href="https://www.facebook.com/profile.php?id=61567292198505" target="_blank" aria-label="Facebook" class="social-icon facebook">
                  <i class="bi bi-facebook"></i>
                </a>
                <a href="https://www.instagram.com/technopaws_us" target="_blank" aria-label="Instagram" class="social-icon instagram">
                  <i class="bi bi-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/company/technopaws" target="_blank" aria-label="LinkedIn" class="social-icon linkedin">
                  <i class="bi bi-linkedin"></i>
                </a>
                <a href="https://www.youtube.com/@technopawsco" target="_blank" aria-label="YouTube" class="social-icon youtube">
                  <i class="bi bi-youtube"></i>
                </a>
                <a href="https://www.tiktok.com/@technopaws_us" target="_blank" aria-label="Tiktok" class="social-icon tiktok">
                  <i class="bi bi-tiktok"></i>
                </a>
              </div>
            </li>
            <li>
              <button class="register-btn mobile" @click="goToHomeAndClose">{{ translate('landing.discover_pawpulse', 'Discover PawPulse - Sign In!') }}</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'TechnopawsHeader',
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : ''
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      document.body.style.overflow = ''
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        const headerHeight = document.querySelector('.header').offsetHeight
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollToSectionAndClose(sectionId) {
      this.closeMobileMenu()
      this.$nextTick(() => {
        this.scrollToSection(sectionId)
      })
    },
    scrollToTopAndClose() {
      this.closeMobileMenu()
      this.$nextTick(() => {
        this.scrollToTop()
      })
    },
    goToHome() {
      this.$router.push('/home')
    },
    goToHomeAndClose() {
      this.closeMobileMenu()
      this.$nextTick(() => {
        this.$router.push('/home')
      })
    }
  }
}
</script>

<style scoped>
:root, body, * {
  font-family: 'Montserrat', 'Arial', sans-serif;
}

:root {
  /* Variables globales si son necesarias */
}

.header {
  background-color: #09405c;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
}

.header-content {
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  flex-shrink: 0;
}

.logo-img {
  height: 67px;
  width: auto;
}

.desktop-menu {
  margin-left: 2rem;
}

.nav-links {
  display: flex;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #4db5ff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 2rem;
}

/* Los estilos de los iconos sociales ahora vienen de las clases globales en App.vue */

.register-btn {
  background-color: #f3a161;
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  font-weight: 500;
  background-color: #f3a161;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
}

.mobile-menu-btn span {
  display: block;
  width: 24px;
  height: 2px;
  background-color: white;
  position: relative;
  transition: background-color 0.3s;
}

.mobile-menu-btn span::before,
.mobile-menu-btn span::after {
  content: '';
  position: absolute;
  width: 24px;
  height: 2px;
  background-color: white;
  transition: transform 0.3s;
}

.mobile-menu-btn span::before {
  top: -6px;
}

.mobile-menu-btn span::after {
  bottom: -6px;
}

.mobile-menu-btn span.open {
  background-color: transparent;
}

.mobile-menu-btn span.open::before {
  transform: rotate(45deg) translate(4px, 6px);
}

.mobile-menu-btn span.open::after {
  transform: rotate(-45deg) translate(4px, -6px);
}

.mobile-menu {
  display: none;
  position: fixed;
  top: 72px;
  left: 0;
  width: 100%;
  height: calc(100vh - 72px);
  background-color: #09405c;
  padding: 2rem;
  transform: translateX(100%);
  transition: transform 0.3s;
}

.mobile-menu.open {
  transform: translateX(0);
}

.mobile-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu li {
  margin-bottom: 1.5rem;
}

.mobile-menu a {
  color: white;
  text-decoration: none;
  font-size: 1.2rem;
}

.mobile-social {
  margin: 2rem 0;
  display: flex;
  justify-content: center;
  width: 100%;
}

.mobile-social .social-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.register-btn.mobile {
  width: 100%;
  padding: 1rem;
}

@media (max-width: 1024px) {
  .desktop-menu,
  .header-right {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-menu {
    display: block;
  }
}

.aboutus-dropdown {
  position: relative;
}

.aboutus-menu {
  display: none;
  position: absolute;
  top: 2.5rem;
  left: 0;
  background: #09405c;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  min-width: 180px;
  padding: 0.5rem 0;
  z-index: 1001;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
}

.aboutus-dropdown:hover .aboutus-menu,
.aboutus-dropdown:focus-within .aboutus-menu {
  display: block;
  opacity: 1;
  pointer-events: auto;
}

.aboutus-menu li {
  margin: 0;
}

.aboutus-menu a {
  color: white;
  padding: 0.5rem 1.2rem;
  display: block;
  text-decoration: none;
  font-size: 1rem;
  transition: background 0.2s;
}

.aboutus-menu a:hover {
  background: #4db5ff;
  color: #09405c;
}

@media (max-width: 1024px) {
  .aboutus-menu {
    display: none !important;
  }
}
</style>
